import React from 'react';
import About from '../../components/About/About';
import SideBar from '../../components/SideBar/SideBar';

const AboutUs = () => {
    return (
        <div className='container'>
            <About/>
            <SideBar/>
        </div>
    );
};

export default AboutUs;